import React, { useEffect, useRef } from "react"
import { styled } from "../../../stitches.config";

const OmniCalculator = () => {
    const ref = useRef(null);
    useEffect(() => {
        const script = document.createElement("script");

        script.src = "https://cdn.omnicalculator.com/sdk.js"
        script.async = true

        ref.current.appendChild(script)
    }, [])
    return (
        <Wrap ref={ref}>
            <div class="omni-calculator" data-calculator="health/kolejka-szczepionkowa" data-width="300" data-config='{}' data-currency="PLN" data-show-row-controls="false" data-version="3" data-t="1610361482335">
                <div class="omni-calculator-header">Kalkulator Kolejki Szczepionkowej COVID-19</div>
                <div class="omni-calculator-footer">
                    <a href="https://www.omnicalculator.com/health/kolejka-szczepionkowa" target="_blank"><img alt="Omni" class="omni-calculator-logo" src="https://cdn.omnicalculator.com/embed/omni-calculator-logo-long.svg" /></a>
                </div>
            </div>
        </Wrap>
    )
}

const Wrap = styled("div", {
    width: "auto",
    ".omni-calculator": {
        margin: "0 auto !important",
        width: "100% !important"
    }
});

export default OmniCalculator